var _defs, _mask, _path, _path2, _path3, _defs2, _mask2, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoStaging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59.4 67.1",
    width: 59.4,
    height: 67.1,
    style: {
      enableBackground: "new 0 0 59.4 67.1"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36.2,
    height: 53.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{opacity:0.5;mask:url(#prefix__b_2_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st3{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st4{opacity:0.9;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st5{enable-background:new    ;}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st7{mask:url(#prefix__d_2_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st9{mask:url(#prefix__f_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st11{mask:url(#prefix__h_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n"))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.2937,
    y1: 16.254,
    x2: 33.9693,
    y2: 37.6194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    style: {
      stopColor: "rgb(251, 214, 4)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    style: {
      stopColor: "rgb(188, 138, 5)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    style: {
      stopColor: "rgb(68, 44, 10)"
    }
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36.2,
    height: 53.8,
    id: "prefix__b_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a_2_",
    className: "st1",
    d: "M0,0h36.2v53.8H0V0z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.0747,
    y1: 20.4688,
    x2: 40.7494,
    y2: 41.8337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    style: {
      stopColor: "rgb(251, 214, 4)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "rgb(188, 138, 5)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    style: {
      stopColor: "rgb(68, 44, 10)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1458,
    y1: 25.0072,
    x2: 48.8209,
    y2: 46.3723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    style: {
      stopColor: "rgb(251, 214, 4)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    style: {
      stopColor: "rgb(188, 138, 5)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    style: {
      stopColor: "rgb(68, 44, 10)"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.8,12.8L26,1.3c5.5-2.5,8.8-1.4,10.1,3.4c0,6.8,0,14.9,0,24.5c0,5.1-1.4,8.5-4.2,10.3 C29.1,41.3,21.4,45.8,8.7,53c-4.8,1.9-7.7,0.3-8.6-4.7C0,40-0.1,29.2,0.2,22.8C0.3,18.1,2.5,14.8,6.8,12.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.5,17L32.8,5.5c5.5-2.5,8.8-1.4,10.1,3.4c0,6.8,0,14.9,0,24.5c0,5.1-1.4,8.5-4.2,10.3 c-2.8,1.8-10.6,6.3-23.3,13.5c-4.8,1.9-7.7,0.3-8.6-4.7C6.8,44.2,6.7,33.4,7,27C7.1,22.3,9.3,19,13.5,17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.6,21.5L40.9,10c5.5-2.5,8.8-1.4,10.1,3.4c0,6.8,0,14.9,0,24.5c0,5.1-1.4,8.5-4.2,10.3 c-2.8,1.8-10.6,6.3-23.3,13.5c-4.8,1.9-7.7,0.3-8.6-4.7c0-8.3-0.2-19.1,0.2-25.5C15.2,26.9,17.4,23.6,21.6,21.5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 23.246, 13.291)",
    className: "st5"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36.2,
    height: 53.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36.2,
    height: 53.8,
    id: "prefix__d_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__c_2_",
    className: "st1",
    d: "M0,0h36.2v53.8H0V0z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.2937,
    y1: 16.254,
    x2: 33.9693,
    y2: 37.6194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    style: {
      stopColor: "rgb(251, 214, 4)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    style: {
      stopColor: "rgb(188, 138, 5)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "rgb(68, 44, 10)"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M6.8,12.8L26,1.3c5.5-2.5,8.8-1.4,10.1,3.4c0,6.8,0,14.9,0,24.5c0,5.1-1.4,8.5-4.2,10.3 C29.1,41.3,21.4,45.8,8.7,53c-4.8,1.9-7.7,0.3-8.6-4.7C0,40-0.1,29.2,0.2,22.8C0.3,18.1,2.5,14.8,6.8,12.8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 32.931999, 28.528)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 0.2,
    y: 7.9,
    width: 8.4,
    height: 14.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.2,
    y: 7.9,
    width: 8.4,
    height: 14.2,
    id: "prefix__f_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__e_2_",
    className: "st1",
    d: "M18.9,0l0,13.8L0.2,24.6l0-13.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.1,8C4.9,8.1,4.7,8.3,4.6,8.5C4.4,8.8,4.3,9,4,9.6L0.4,20.1c-0.2,0.5-0.3,0.9-0.3,1.2c0,0.4,0.1,0.6,0.4,0.7 c0.3,0.1,0.6,0,1.2-0.3l3.1-1.8l0,0.4c0,0.6,0,0.8,0.1,1c0.2,0.3,0.5,0.3,0.9,0c0.4-0.3,0.8-0.7,0.9-1.1c0.1-0.3,0.1-0.6,0.1-1.2 l0-0.4l0.3-0.2c0.5-0.3,0.7-0.4,0.9-0.7c0.3-0.3,0.5-0.8,0.5-1.3c0-0.5-0.2-0.7-0.5-0.7c-0.2,0-0.4,0.1-0.9,0.4l-0.3,0.2l0-1.1 c0-0.6,0-0.8-0.1-1c-0.2-0.3-0.5-0.3-0.9-0.1c-0.4,0.3-0.8,0.7-0.9,1.1c-0.1,0.3-0.1,0.6-0.1,1.2l0,1.1l-2.1,1.2l3.2-9.2 C6.1,9,6.1,8.8,6.1,8.5C6.1,7.9,5.6,7.7,5.1,8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 10.2,
    y: 1.9,
    width: 8.6,
    height: 16.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 10.2,
    y: 1.9,
    width: 8.6,
    height: 16.3,
    id: "prefix__h_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__g_2_",
    className: "st1",
    d: "M18.9,0l0,13.8L0.2,24.6l0-13.8"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M 12.028 10.307 L 11.715 5.852 C 11.819 5.119 10.8 4.7 10.5 5.3 C 10.2 5.9 10.2 6.4 10.2 6.7 L 10.2 17.1 C 10.2 17.5 10.2 18 10.5 18.2 C 10.8 18.4 11.3 18.1 11.6 17.9 L 14.5 16.2 C 16.1 15.3 17.162 14.874 18.062 12.874 C 18.762 11.274 17.862 9.875 17.062 9.075 C 16.162 8.375 13.628 9.407 12.028 10.307 M 12.6 15 L 12.6 12.036 L 15.435 10.59 C 16.235 10.09 17.156 11.343 16.656 12.243 C 16.256 13.043 15.395 13.543 14.595 13.943 L 12.6 15"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStaging);
export default __webpack_public_path__ + "static/media/logo-staging.59f2e630ba98c4cbe650ad2f2720f2d3.svg";
export { ForwardRef as ReactComponent };